// https://github.com/minhtranite/react-notifications
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
export default { NotificationContainer, NotificationManager };
